<template>
    <div class="second-rule-box">
        <div class="second-rule-header">
            <div class="second-rule-header-text">二级指标名称</div>
            <div class="action-button">
                <ActionButton :on-click="handleActionButtonClick" />
            </div>
        </div>
        <div class="second-rule-content">
            <div class="video-box"></div>
            <div class="divider"></div>
            <div class="score-box">
                <div class="score-content">
                    <div>
                        <span class="big-score">18</span><span class="small-score">/20</span>
                    </div>
                    <div class="score-text">总评分</div>
                </div>
            </div>
            <div class="divider"></div>
            <div class="text-box">
                建议教师在后续教学中进一步优化个别教学环节，以实现更高层次的教学提升:1.**针对高阶学生的个性化反馈料，在小组分享或展示环节(如39:00-39:20)，可尝试提出更具挑战性的问题，如“你认为什么样的名字最能代表一个人的价值观?’，从而激发学生进行批判性思考和创造性表达;2.**在语言表达支架的精细化设计上*，可以考虑根据不同学生的表达水平提供分层支持，例如在学生组织语言用难时(如22:05)，除提示“连起来讲’外，还可引入可视化流程图或关键词卡片辅助其构建逻辑结构:3.*在课堂节奏控制方面**，可在拓展提升部分(如46:23-47:19)适当压缩部分内容，为更多学生提供表达机会，避免少数高水平学生的发言占据过多时间;4.*在跨学科资源的整合策略上*，建议教师在讲解历史人物或文化典故时(如李白的故事43:06-45:45)，增加学生自主探究环节，如设置'我来猜名号’的小任务，增强学生主动建构知识的能力:5.**在课堂小结环节*，可引导学生自行总结“我们今天学到了哪些讲述故事的方法’，以此强化学生对学习策略的自我反思与迁移能力。以上建议旨在帮助教师在已有基础上进一步提升教学的差异化实施能力，满足不同层次学生的发展需求，推动课堂教学向更高...建议教师在后续教学中进一步优化个别教学环节，以实现更高层次的教学提升:1.**针对高阶学生的个性化反馈料，在小组分享或展示环节(如39:00-39:20)，可尝试提出更具挑战性的问题，如“你认为什么样的名字最能代表一个人的价值观?’，从而激发学生进行批判性思考和创造性表达;2.**在语言表达支架的精细化设计上*，可以考虑根据不同学生的表达水平提供分层支持，例如在学生组织语言用难时(如22:05)，除提示“连起来讲’外，还可引入可视化流程图或关键词卡片辅助其构建逻辑结构:3.*在课堂节奏控制方面**，可在拓展提升部分(如46:23-47:19)适当压缩部分内容，为更多学生提供表达机会，避免少数高水平学生的发言占据过多时间;4.*在跨学科资源的整合策略上*，建议教师在讲解历史人物或文化典故时(如李白的故事43:06-45:45)，增加学生自主探究环节，如设置'我来猜名号’的小任务，增强学生主动建构知识的能力:5.**在课堂小结环节*，可引导学生自行总结“我们今天学到了哪些讲述故事的方法’，以此强化学生对学习策略的自我反思与迁移能力。以上建议旨在帮助教师在已有基础上进一步提升教学的差异化实施能力，满足不同层次学生的发展需求，推动课堂教学向更高...
            </div>
        </div>
    </div>
</template>
<script>
import ActionButton from './ActionButton.vue';
export default {
    name: 'SecondRule',
    components: {
        ActionButton,
    },
    methods: {
        handleActionButtonClick(type) {
            console.log(`在SecondRule中点击了${type}按钮`);
            // 这里可以添加具体的业务逻辑处理
        }
    }
}
</script>
<style lang="less" scoped>
.second-rule-box {
    width: 100%;
    display: flex;
    flex-direction: column;
    background: rgba(0, 28, 53, 0.7);
    box-sizing: border-box;
    border: 1px solid;
    margin-bottom: 20px;
    border-image: linear-gradient(0deg, rgba(5, 133, 247, 0.3) 0%, rgba(5, 133, 247, 0.2) 50%, rgba(5, 133, 247, 0.2) 100%) 1;

    .second-rule-header {
        height: 40px;
        width: 100%;
        background: linear-gradient(90deg, rgba(13, 80, 146, 0.5) 0%, rgba(13, 80, 146, 0.5) 100%);
        position: relative;

        .second-rule-header-text {
            color: #ffffff;
            font-size: 20px;
            text-align: center;
            line-height: 40px;
            /* 与header高度一致，确保垂直居中 */
            background: url(../.././../assets/image/rule-name-bg.png) no-repeat;
            width: 420px;
            position: relative;
            left: 50%;
            transform: translateX(-50%);
            z-index: 1;
            /* 确保标题在按钮上方 */
        }

        .action-button {
            position: absolute;
            right: 10px;
            /* 调整右侧间距 */
            top: 50%;
            transform: translateY(-50%);
            /* 垂直居中 */
            display: flex;
            align-items: center;
        }
    }

    .second-rule-content {
        display: flex;
        flex-direction: row;
        height: 280px;
        padding: 20px;


        .divider {
            width: 1px;
            height: 100%;
            background: #043B6A;
            margin: 0 20px;
        }

        .video-box {
            width: 480px;
            height: 100%;
            background-color: red;
        }

        .score-box {
            width: 135px;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .score-content{
                display: flex;
                align-items: center;
                background: url(../../../assets/image/score-bg2.png) no-repeat;
                width: 133px;
                height: 140px;
                flex-direction: column;
                gap: 10px;
                box-sizing: border-box;
                padding-top: 22px;
            }

            .big-score {
                color: #00FFC6;
                font-size: 28px;
                font-weight: 600;
            }

            .small-score {
                color: #fff;
                font-size: 16px;
                font-weight: 600;
            }

            .score-text {
                color: #fff;
                font-size: 14px;
            }
        }

        .text-box {
            height: 100%;
            color: #fff;
            font-size: 18px;
            line-height: 34px;
            font-weight: 400;
            flex: 1;
            overflow-y: auto;
            overflow-x: hidden;
            box-sizing: border-box;

            /* 自定义滚动条样式 */
            &::-webkit-scrollbar {
                width: 8px;
            }

            &::-webkit-scrollbar-track {
                background: rgba(0, 28, 53, 0.1);
                border-radius: 4px;
            }

            &::-webkit-scrollbar-thumb {
                background: rgba(5, 133, 247, 0.5);
                border-radius: 4px;
            }

            &::-webkit-scrollbar-thumb:hover {
                background: rgba(5, 133, 247, 0.8);
            }
        }
    }
}
</style>